export const HOMESCREEN_PATH = "/";

export const OAUTH_CALLBACK_PATH = "/oauth/callback";

export const CALCULATION_PATH = "/calculation";

export const ECONAUT_DEMO_PATH = "/econaut-demo";

export const ECONAUT_AT_A_GLANCE_PATH = `${ECONAUT_DEMO_PATH}/at-a-glance`;
